import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';

import { ProxyService, AlertService, ValidationService, ModalService } from '@core/services';
import { Subscription } from 'rxjs';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { EditFavoriteService } from '@core/services/edit-favorite.service';
import { UpdateTrigger } from '@shared/components/validation-message';

@Component({
  selector: 'app-edit-favorite',
  templateUrl: './edit-favorite.component.html',
  styleUrls: ['./edit-favorite.component.less'],
  providers: [AlertService]
})
export class EditFavoriteComponent implements OnInit {

  form: UntypedFormGroup;
  public loading: boolean;
  private subscriptions = new Subscription();
  // Set enum from validation message service to be a member variable of this class
  updateTrigger: any = UpdateTrigger;

  constructor(
    private proxyService: ProxyService,
    private builder: UntypedFormBuilder,
    private modalService: ModalService,
    private alertService: AlertService,
    private editFavoriteService: EditFavoriteService
  ) {
    this.form = builder.group({
      favName: new UntypedFormControl(null, [Validators.required, ValidationService.validateFavName]),
    });

    const favoriteName = sessionStorage.getItem('favoriteName') as string;

    if (favoriteName) {
      this.form.controls.favName.setValue(favoriteName);
    }
  }

  ngOnInit() {
  }

  onSubmit(form) {
    const favId = sessionStorage.getItem('favOrderId');
    this.loading = true;

    const parameters = form.favName;

    this.subscriptions.add(
      this.proxyService.httpPut(ApiRoutes.GET_FAVORITES + '/' + favId + '/rename', JSON.stringify(parameters)).subscribe(
        (success) => {
          setTimeout(() => {
            this.editFavoriteService.updateFavName(form.favName);
            this.loading = false;
            this.modalService.hideModal();
          }, 3000);
        },
        (err) => {
          this.alertService.error(err.error.message);
          this.loading = false;
        }
      ));
  }

  childClosed() {
    this.modalService.hideModal();
  }

}
